import { useEffect } from 'react';
import { pollNewsNotifications } from '../utils/newsNotifications';

export default function NewsNotificationDelivery() {
  useEffect(() => {
    let busy = false;
    const poll = async () => {
      if (busy) return;
      busy = true;
      try {
        // Serialize tabs on browsers supporting Web Locks. The durable batch
        // marker also prevents redisplay if an acknowledgement must be retried.
        if (navigator.locks) await navigator.locks.request('jaosve-news', { ifAvailable: true }, lock => lock && pollNewsNotifications());
        else await pollNewsNotifications();
      } catch (error) {
        window.dispatchEvent(new CustomEvent('news-notification-error', { detail: error.message }));
      } finally { busy = false; }
    };
    poll();
    const timer = setInterval(poll, 60000);
    window.addEventListener('focus', poll);
    window.addEventListener('news-notifications-changed', poll);
    return () => {
      clearInterval(timer);
      window.removeEventListener('focus', poll);
      window.removeEventListener('news-notifications-changed', poll);
    };
  }, []);
  return null;
}
